<template>
    <ScrollableView class="bg-green">

        <div class="mx-auto py-8 max-w-sm text-center text-90">
            <img src="/logo.svg" style="height: 40px;" class="inline"></div>

            <div class="bg-white shadow rounded-lg p-8">

                <h2 class="text-2xl text-center font-normal mb-6 text-90">{{ $t("Set Password") }}</h2>
                <svg class="block mx-auto mb-6" xmlns="http://www.w3.org/2000/svg" width="100" height="2" viewBox="0 0 100 2"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="08-login" fill="#D8E3EC" transform="translate(-650 -371)"><path id="Rectangle-15" d="M650 371h100v2H650z"></path></g></g></svg>

                <div v-show="errors.classifiedServerError" class="text-center font-semibold text-red my-3">
                    {{ errors.classifiedServerError }}
                </div>

                <input-control :label="$t('E-mail address')">
                <input
                    id="email"
                    v-model.trim.lazy="$v.email.$model"
                    type="text"
                    name="email"
                    :placeholder="$t('E-mail address')"
                    :class="inputClass($v.email.$anyError)"
                    disabled
                />
                <div v-if="$v.email.$dirty">
                    <input-error :condition="!$v.email.required">
                    {{ $t('The {field} field is required', { field: $t('e-mail address') }) }}
                    </input-error>
                    <input-error :condition="!$v.email.email">
                    {{ $t('The e-mail address is not valid') }}
                    </input-error>
                </div>
                </input-control>

                <input-control :label="$t('Password')">
                <input
                    id="password"
                    v-model.trim.lazy="$v.password.$model"
                    type="password"
                    name="password"
                    :placeholder="$t('new password')"
                    :class="inputClass($v.password.$anyError)"
                />
                <div v-if="$v.password.$dirty">
                    <input-error :condition="!$v.password.required">
                        {{ $t('The {field} field is required', { field: $t('password') }) }}
                    </input-error>
                    <input-error :condition="!$v.password.minLength">{{ $t('The password must be at least 6 characters long.') }}</input-error>
                </div>
                </input-control>

                <input-control :label="$t('Password Confirmation')">
                <input
                    id="password_confirmation"
                    v-model.trim.lazy="$v.password_confirmation.$model"
                    type="password"
                    name="password_confirmation"
                    :placeholder="$t('confirm new password')"
                    autocomplete="new-password"
                    :class="inputClass($v.password_confirmation.$anyError)"
                />
                <div v-if="$v.password_confirmation.$dirty">
                    <input-error :condition="!$v.password_confirmation.sameAsPassword">{{ $t('The password confirmation does not match the password.') }}</input-error>
                </div>
                </input-control>

                <button class="w-full btn btn-default btn-primary bg-red" type="submit" @click.prevent="handleSubmit">
                    {{ $t("Set Password") }}
                </button>
            </div>
        </ScrollableView>
</template>

<script>

import { userService } from '@mobile/services/user';
import { errorHandler } from '@mobile/services/errorHandler';
import ScrollableView from '@mobile/components/ScrollableView.vue';
import {
    required, email, minLength, sameAs,
} from 'vuelidate/lib/validators';
import { eventBus } from '@/eventBus';

import InputControl from '../components/Form/InputControl.vue';
import InputError from '../components/Form/InputError.vue';

export default {
    components: {
        'input-control': InputControl,
        'input-error': InputError,
        ScrollableView,
    },
    props: {
        encodedEmail: {
            required: true,
        },
        token: {
            required: true,
        },
    },
    created() {
        try {
            this.email = atob(this.encodedEmail);
        } catch (e) {
            this.email = this.encodedEmail;
        }
    },
    data() {
        return {
            email: '',
            password_confirmation: '',
            password: '',
            errors: {
                classifiedServerError: null,
            },
        };
    },
    validations: {
        email: { required, email },
        password: { required, minLength: minLength(6) },
        password_confirmation: { required, sameAsPassword: sameAs('password') },
    },
    methods: {
        handleSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            this.errors.classifiedServerError = null;

            userService.resetPassword(this.email, this.password, this.password_confirmation, this.token)
                .then(() => {
                    this.logInUser(this.email, this.password);
                }).catch((error) => {
                    const httpErrorMessage = errorHandler.handle(error);
                    if (httpErrorMessage === null) {
                        eventBus.$emit('error', this.$t('Connection error!'));
                        return;
                    }

                    this.errors.classifiedServerError = this.$t(httpErrorMessage);
                });
        },
        logInUser(email, password) {
            this.$store.dispatch('authentication/login', { email, password });
        },
        inputClass(error = false) {
            return {
                'w-full': true,
                'form-control': true,
                'form-input': true,
                'form-input-bordered': true,
                'border-red': error,
            };
        },
    },
};
</script>
